import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/authSlice';
import projectReducer from '../features/projectSlice';
import parentReducer from '../features/parentSlice';
import calendarReducer from '../features/calenderSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    project: projectReducer,
    parent: parentReducer,
    calendar: calendarReducer
  },
});